<template>
  <div
    class="wrapper"
    :class="{ 'full-page': !userIsLogged}"
    style
    data-image="../../../static/img/sidebar-donapp.jpg"
  >
    <side-bar v-if="userIsLogged" v-show="route.fullPath !== '/change-role'"/>
    <top-bar v-if="userIsLogged"/>
    <div :class="{'main-panel': userIsLogged, 'full-width': route.fullPath === '/change-role'}">
      <div class="content">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from './TopBar'
import SideBar from './SideBar'
import Login from './Login'
import { mapState } from 'vuex'

export default {
  name: 'wrapper',
  components: {
    Login,
    TopBar,
    SideBar
  },
  data: function() {
    return {
      show: true,
      updatePaymentMethodsToast: undefined
    }
  },
  created: function() {
    this.$store.watch(
      state =>
        state.user.loggedRole && state.user.loggedRole.merchant
          ? state.user.loggedRole.merchant.donation
          : null,
      newValue => {
        const hasValidCreditCard =
          newValue &&
          newValue.stripe &&
          newValue.stripe.creditCard &&
          newValue.stripe.creditCard.valid
        const hasValidSepa =
          newValue &&
          newValue.stripe &&
          newValue.stripe.sepa &&
          newValue.stripe.sepa.valid
        const hasValidPaymentMethod =
          (hasValidCreditCard &&
            newValue.stripe.paymentMethod === 'creditCard') ||
          (hasValidSepa && newValue.stripe.paymentMethod === 'sepa')

        if (
          newValue &&
          !this.updatePaymentMethodsToast &&
          !hasValidPaymentMethod
        ) {
          this.updatePaymentMethodsToast = this.$toasted.show(
            this.$i18n.t('messages.payment_method_need_update'),
            {
              duration: null,
              position: 'top-center',
              action: [
                {
                  text: this.$i18n.t('labels.go'),
                  push: {
                    name: 'MerchantProfile',
                    query: { sub: 1, session: Date.now() },
                    dontClose: true
                  }
                }
              ]
            }
          )
        } else if (!newValue || hasValidPaymentMethod) {
          this.updatePaymentMethodsToast &&
            this.updatePaymentMethodsToast.remove()
          this.updatePaymentMethodsToast = null
        }
      },
      { deep: true }
    )
  },
  computed: mapState({
    route: state => state.route,
    userIsLogged: state => state.userIsLogged
  })
}
</script>

<style scoped lang="scss">
@import '../../scss/config';

.main-panel {
  min-height: 100%;
  width: calc(100% - 260px);
}

.main-panel.full-width {
  width: 100%;
}

.full-page:before {
  background-color: rgba(0, 0, 0, 0.5);
}

.full-page[data-image]:after {
  opacity: 0.8;
}

.full-page:after,
.full-page:before {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
}

.full-page {
  background-image: url(../../../static/img/sidebar-donapp.jpg);
}

.content {
  min-height: calc(100vh - 152px);
}

.main-panel > .content {
  margin-top: $topbarHeight;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Wrapper.vue